import React, { useState, useCallback, useEffect, forwardRef } from "react";
import { Stack, Text, Icon } from "@shopify/polaris";
import {
  TextBlockMajor,
  ImageMajor,
  ImageWithTextMajor,
  ListMajor,
  PlayCircleMajor,
  CollectionsMajor,
  CodeMajor,
  CategoriesMajor,
  ClockMajor,
  DetailedPopUpMajor,
  ChannelsMajor,
  NavigationMajor,
  SectionMajor,
  TextMajor,
} from "@shopify/polaris-icons";
import "react-sliding-pane/dist/react-sliding-pane.css";

export const SectionCollapseOutside = forwardRef((props, ref) => {
  const switchTitle = (param) => {
    switch (param) {
      case "rich_text":
        return "Rich Text";
      case "banner":
        return "Banner";
      case "image":
        return "Image with text";
      case "list":
        return "List";
      case "video":
        return "Video";
      case "shopify_collection":
        return "Shopify Collection";
      case "code":
        return "code";
      case "shopify_products_list":
        return "List of Shopify Products";
      case "countdown":
        return "Countdown";
      case "navigation":
        return "Navigation";
      case "popup":
        return "Popup";
      case "object":
        return "Object";
      case "iframe":
        return "Iframe";
      case "custom_block":
        return "Custom Block";
      default:
        return null;
    }
  };
  const switchIcon = (param) => {
    switch (param) {
      case "rich_text":
        return TextBlockMajor;
      case "banner":
        return ImageMajor;
      case "image":
        return ImageWithTextMajor;
      case "list":
        return ListMajor;
      case "video":
        return PlayCircleMajor;
      case "shopify_collection":
        return CollectionsMajor;
      case "code":
        return CodeMajor;
      case "shopify_products_list":
        return CategoriesMajor;
      case "countdown":
        return ClockMajor;
      case "popup":
        return DetailedPopUpMajor;
      case "navigation":
        return NavigationMajor;
      case "object":
        return SectionMajor;
      case "iframe":
        return CodeMajor;
      case "custom_block":
        return TextMajor;
      default:
        return "";
    }
  };

  return (
    <div>
      <div className="accordion-item" id={props.id}>
        <h2
          className="accordion-header"
          id="heading-m3q819"
          {...props.dragHandleProps}
        >
          <div
            onClick={() => {
              props.updateOpenArrayStateClose(props.sectionId);
            }}
            role="button"
            tabIndex="0"
            className={`accordion-button collapsed`}
            type="button"
            aria-expanded="false"
            aria-controls="collapse-m3q819"
            aria-label="aa"
          >
            {
              <Stack horizontal alignment="center">
                <Stack.Item>
                  <div
                    style={{
                      minWidth: "10rem",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <div style={{ width: "2rem", opacity: "0.5" }}>
                      <Icon source={switchIcon(props.type)} color="subdued" />
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Text variant="bodyMd" as="p" fontWeight="regular">
                        {`${
                          JSON.parse(props?.object) &&
                          JSON.parse(props?.object)?.title["en"]
                            ? `${JSON.parse(props?.object)
                                .title["en"].replace(/<[^>]+>/g, "")
                                .replace(/&nbsp;/g, "")
                                .replaceAll(";;;", " ")}`
                            : switchTitle(props.type)
                        }`}
                      </Text>
                    </div>
                  </div>
                </Stack.Item>
              </Stack>
            }
          </div>
        </h2>
      </div>
    </div>
  );
});
